/* eslint-disable no-plusplus */
/* eslint-disable no-promise-executor-return */
import { themeColor } from './theme/themeVariables';

const QRCode = require('qrcode')

const config = {
  topMenu: false,
  rtl: false,
  mainTemplate: 'lightMode',
  themeColor,
};

export const FORM_HIDE_TIMEOUT_SECONDS = 1;


// // export const API_ENDPOINT = `${process.env.REACT_APP_API_ENDPOINT}/api`;
export const API_ENDPOINT = `${window.location.origin}/api`;
export const SOCKET_END_POINT = `wss://${window.location.host}/api/`;
// export const API_ENDPOINT = `http://localhost:8000/api`;
// export const SOCKET_END_POINT = `ws://localhost:8000/api/`;

export const DOC_FILE_TYPES = [
  {
    id: 1,
    label: 'Image',
  },
  {
    id: 2,
    label: 'PDF',
  },
]

export const DOC_TYPES = [
  {
    id: 1,
    label: 'Application to Chairman APSAA for Membership',
  },
  {
    id: 2,
    label: 'Company Profile (Brief Introductory)',
  },
  {
    id: 3,
    label: 'Operating License (any province)',
  },
  {
    id: 4,
    label: 'NOC of MOI',
  },
  {
    id: 5,
    label: 'Certified Copy of Incorporation Certificate by SECP',
  },
  {
    id: 6,
    label: 'Memorandum & Article of Association of the Company',
  },
  {
    id: 7,
    label: 'Form-29 Attested by SECP updated',
  },
  {
    id: 8,
    label: 'Copy of NTN & SRB (PRA/BRA/KPK)',
  },
  {
    id: 9,
    label: 'Copy of EOBI & Social Security Registration',
  },
  {
    id: 10,
    label: 'Copy of Utility Bills (Electric, Land Line & Gas)',
  },
  {
    id: 11,
    label: 'Pay Order Rs-55000.by the name of All Pakistan Security Agencies Association',
  },
]

export const ZONES = [
  // {
  //   id: 1,
  //   label: 'EAST'
  // },
  // {
  //   id: 2,
  //   label: 'WEST'
  // },
  {
    id: 3,
    label: 'NORTH'
  },
  {
    id: 4,
    label: 'SOUTH'
  },
]

export const VERIFICATION_RESULT_TYPE = {
  MEMBERSHIP_CARD: 1,
  EMPLOYEE_ID_CARD: 2,
  TRAINING_CERTIFICATE: 3,
}

export const BLOOD_GROUPS = [
  { id: 0, label: 'N / A' },
  { id: 1, label: 'A+' },
  { id: 2, label: 'A-' },
  { id: 3, label: 'B+' },
  { id: 4, label: 'B-' },
  { id: 5, label: 'O+' },
  { id: 6, label: 'O-' },
  { id: 7, label: 'AB+' },
  { id: 8, label: 'AB-' },
];

export const EMPLOYEE_TYPE = [
  { id: 1, label: 'Civilian' },
  { id: 2, label: 'Ex-Service Man' },
  { id: 3, label: 'SSG Commando' },
];

// PENDING: 0,
// APPROVED: 1,
// REJECTED: 2,
// CANCEL: 3,
// SYSTEM_CANCEL: 4

export const UPDATE_REQUEST_STATUS = [
  { id: 0, label: 'Pending' },
  { id: 1, label: 'Approved' },
  { id: 2, label: 'Rejected' },
  { id: 3, label: 'Cancel' },
  { id: 4, label: 'System Cancelled' },
];

export const UPDATE_REQUEST_STATUS_JSON = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
  CANCEL: 3,
  SYSTEM_CANCEL: 4
}

export const GENDERS = [
  { id: 1, label: 'Male' },
  { id: 2, label: 'Female' },
  { id: 3, label: 'Transgender' }
];

// export const SECURITY_COMPANY_DESIGNATIONS = [
//   { id: 1, label: 'Chairman' },
//   { id: 2, label: 'Chief Executive Officer (CEO)' },
//   { id: 3, label: 'Managing Director (MD)' },
//   { id: 4, label: 'Director Operations' },
//   { id: 5, label: 'Director Security' },
//   { id: 6, label: 'General Manager Operations' },
//   { id: 7, label: 'General Manager Security' },
//   { id: 8, label: 'Deputy General Manager' },
//   { id: 9, label: 'Regional Manager' },
//   { id: 10, label: 'Zone Manager' },
//   { id: 11, label: 'Area Manager' },
//   { id: 12, label: 'Branch Manager' },
//   { id: 13, label: 'Assistant Manager Operations' },
//   { id: 14, label: 'Assistant Manager Security' },
//   { id: 15, label: 'Training Manager' },
//   { id: 16, label: 'Human Resources Manager' },
//   { id: 17, label: 'Finance Manager' },
//   { id: 18, label: 'Accounts Manager' },
//   { id: 19, label: 'Control Room Supervisor' },
//   { id: 20, label: 'Control Room Operator' },
//   { id: 21, label: 'Field Officer' },
//   { id: 22, label: 'Security Coordinator' },
//   { id: 23, label: 'Shift In-charge' },
//   { id: 24, label: 'Patrol Supervisor' },
//   { id: 25, label: 'Security Guard' },
//   { id: 26, label: 'Lady Security Guard' },
//   { id: 27, label: 'Dog Handler' },
//   { id: 28, label: 'Driver' },
//   { id: 29, label: 'Armored Vehicle Driver' },
//   { id: 30, label: 'Technician' },
//   { id: 31, label: 'CCTV Operator' },
//   { id: 32, label: 'Alarm Monitoring Officer' },
//   { id: 33, label: 'Operations Assistant' },
//   { id: 34, label: 'Office Assistant' },
//   { id: 35, label: 'Receptionist' },
//   { id: 36, label: 'Peon' },
//   { id: 37, label: 'Janitor' },
//   { id: 38, label: 'Clerical Staff' },
// ];

export const EMP_STATUS_FILTER = [
  { id: -1, label: 'Show All' },
  { id: 1, label: 'Active' },
  { id: 0, label: 'InActive' },
];

export const SOCKET_ACTIONS = {
  USER_CONNECTED: 1,
  UNAUTHORIZED: 2,
  DISCONNECTED: 3,
  NEW_CONNECTION: 4,
  ALREADY_CONNECTED: 5,
  FETCH_NOTIFICATIONS: 6,
  REQUEST_NEW_NOTIFICATIONS: 7,
  RECEIVED_NEW_NOTIFICATIONS: 8,
  TRAINING_REQUEST_CHANGED_BY_ATS: 9,
}

export const USER_ROLES = {
  SUPER_ADMIN: 's-admin',
  ADMINISTRATOR: 'admin',
  COMPANY: 'comp',
  HQ_OPERATOR: 'hq-operator',
  PRINTING_OPERATOR: 'p-operator',
  ATS_OPERATOR: 'ats',
  FINANCE: 'finance',
}

export const EMPLOYEE_EXIT_REASONS = [
  { id: 1, label: 'Better Job Opportunity' },
  { id: 2, label: 'Personal Reasons' },
  { id: 3, label: 'Health Issues' },
  { id: 4, label: 'Relocation' },
  { id: 5, label: 'Retirement' },
  { id: 6, label: 'Pursuing Higher Education' },
  { id: 7, label: 'Starting Own Business' },
  { id: 8, label: 'Job Dissatisfaction' },
  { id: 9, label: 'Performance Issues' },
  { id: 10, label: 'Behavioral Issues' },
  { id: 11, label: 'Policy Violations' },
  { id: 12, label: 'Fraud or Misconduct' },
  { id: 13, label: 'Chronic Absenteeism' },
  { id: 14, label: 'Organizational Restructuring' },
  { id: 15, label: 'Downsizing or Layoff' },
  { id: 16, label: 'Excessive Work Stress' },
  { id: 17, label: 'Lack of Career Growth' },
  { id: 18, label: 'Conflict with Management' },
  { id: 19, label: 'Conflict with Colleagues' },
  { id: 20, label: 'Change in Company Policies' },
  { id: 21, label: 'End of Contract' },
  { id: 22, label: 'Poor Compensation' },
  { id: 23, label: 'Better Work-Life Balance Elsewhere' },
  { id: 24, label: 'Desire to Change Industry' },
  { id: 25, label: 'Involvement in Legal Issues' },
  { id: 26, label: 'Redundancy of Position' },
  { id: 27, label: 'Cultural Mismatch' },
  { id: 28, label: 'Unresolved Workplace Harassment' },
  { id: 29, label: 'Failure to Adapt to Role' },
  { id: 30, label: 'Lack of Recognition or Appreciation' },
];

export const NOTIFICATION_TYPES = {
  1: 'New Training Request',
  2: "New Card Print Request",
  3: "Card Block Request",
  4: 'Update Employee Request',
  5: 'Add EMP To BlackList Request',
  6: 'Employee Sent For Training',
  7: 'Training Request Rejected',
  8: 'Training Request Cancelled Employee is InActive',
  9: 'Training Status Changed By ATS',
  10: 'Card Request Forwarded For Printing',
  11: 'Card Request Rejected',
  12: 'Employee Deactivated',
  13: 'Update Request Approved',
  14: 'Update Request Cancelled',
  15: 'Update Request Canclled By User',
  16: 'Important Document Uploaded',
}

export const NOTIFICATION_READ_STATUS = {
  UNREAD: 0,
  READ: 1
}

export const NOTIFICATION_TYPES_ARRAY = [
  { id: 1, title: 'New Training Request' },
  { id: 2, title: 'New Card Print Request' },
  { id: 3, title: 'Card Block Request' },
  { id: 4, title: 'Update Employee Request' },
  { id: 5, title: 'Add To BlackList Request' },
  { id: 6, title: 'Employee Sent For Training' },
  { id: 7, title: 'Training Request Rejected' },
  { id: 8, title: 'Training Cancelled Employee is InActive' },
  { id: 9, title: 'Training Status Changed By ATS' },
  { id: 10, title: 'Card Request Forwarded For Printing' },
  { id: 11, title: 'Card Request Rejected' },
  { id: 12, title: 'Employee Deactivated' },
  { id: 13, title: 'Update Request Approved' },
  { id: 14, title: 'Update Request Cancelled' },
  { id: 15, title: 'Update Request Canclled By User' },
  { id: 16, title: 'Important Document Uploaded' },
]

export const BLACK_LISTING_REASONS = [
  { "id": 1, "label": "Company property theft" },
  { "id": 2, "label": "Unauthorized access to sensitive information" },
  { "id": 3, "label": "Forgery of documents" },
  { "id": 4, "label": "Fraudulent activities" },
  { "id": 5, "label": "Breach of confidentiality" },
  { "id": 6, "label": "Sexual harassment" },
  { "id": 7, "label": "Violent behavior" },
  { "id": 8, "label": "Substance abuse on company premises" },
  { "id": 9, "label": "Multiple attendance frauds" },
  { "id": 10, "label": "Repeated insubordination" },
  { "id": 11, "label": "Unauthorized use of company resources" },
  { "id": 12, "label": "Misrepresentation of skills/experience" },
  { "id": 13, "label": "Collusion with competitors" },
  { "id": 14, "label": "Bribery or corruption" },
  { "id": 15, "label": "Falsifying company records" },
  { "id": 16, "label": "Threatening colleagues or management" },
  { "id": 17, "label": "Misconduct during company events" },
  { "id": 18, "label": "Violation of safety regulations" },
  { "id": 19, "label": "Absconding from duty" },
  { "id": 20, "label": "Legal issues impacting company reputation" },
  { "id": 21, "label": "Unethical professional behavior" },
  { "id": 22, "label": "Repeated poor performance" },
  { "id": 23, "label": "Misuse of official position" },
  { "id": 24, "label": "Discrimination against colleagues" },
  { "id": 25, "label": "Criminal record revealed during employment" }
]

export const TRAINING_STATUSES = {
  PENDING: 0,
  IN_PROCESS: 1,
  COMPLETED: 2,
  PASSED: 3,
  FAILED: 4,
  REJECTED: 5,
  BLOCKED: 6,
  EMP_INACTIVE: 7,
}

export const TRAINING_STATUSES_FOR_ATS = {
  IN_PROCESS: 1,
  COMPLETED: 2,
  PASSED: 3,
  FAILED: 4,
}

export const CARD_STATUSES = {
  PENDING: 0,
  IN_PROCESS: 1,
  PRINTED: 2,
  EXPIRED: 3,
  REJECTED: 4,
  BLOCKED: 5,
  EMP_INACTIVE: 6,
  DELIVERED: 7,
}

export const CARD_STATUSES_ARRAY = [
  { id: 0, label: 'Pending' },
  { id: 1, label: 'In-Process' },
  { id: 2, label: 'Active' },
  { id: 3, label: 'Expired' },
  { id: 4, label: 'Rejected By APSAA' },
  { id: 5, label: 'Blocked By System' },
  { id: 6, label: 'Employee Left The Organization' },
  { id: 7, label: 'Active' },
]

export const CARD_STATUSES_FOR_PRINTING_OPERATOR = {
  IN_PROCESS: 1,
  PRINTED: 2,
  EXPIRED: 3,
  REJECTED: 4,
}

export const TRAINING_STATUS_COLORS = {
  [TRAINING_STATUSES.PENDING]: {
    color: themeColor['warning-color'],
    label: 'Pending'
  },
  [TRAINING_STATUSES.IN_PROCESS]: {
    color: themeColor['info-color'],
    label: 'In Process'
  },
  [TRAINING_STATUSES.COMPLETED]: {
    color: themeColor['success-color'],
    label: 'Completed'
  },
  [TRAINING_STATUSES.PASSED]: {
    color: themeColor['success-color'],
    label: 'Passed'
  },

  [TRAINING_STATUSES.FAILED]: {
    color: themeColor['error-color'],
    label: 'Failed'
  },

  [TRAINING_STATUSES.REJECTED]: {
    color: themeColor['error-color'],
    label: 'Request Rejected'
  },
  [TRAINING_STATUSES.BLOCKED]: {
    color: themeColor['error-color'],
    label: 'Blocked'
  },
  [TRAINING_STATUSES.EMP_INACTIVE]: {
    color: themeColor['error-color'],
    label: 'Employee InActive'
  },
}

export const CARD_STATUS_COLORS = {
  [CARD_STATUSES.PENDING]: {
    color: themeColor['warning-color'],
    label: 'Pending'
  },
  [CARD_STATUSES.IN_PROCESS]: {
    color: themeColor['info-color'],
    label: 'In Process'
  },
  [CARD_STATUSES.PRINTED]: {
    color: themeColor['success-color'],
    label: 'Printed'
  },
  [CARD_STATUSES.REJECTED]: {
    color: themeColor['error-color'],
    label: 'Request Rejected'
  },
  [CARD_STATUSES.BLOCKED]: {
    color: themeColor['error-color'],
    label: 'Blocked'
  },
  [CARD_STATUSES.EMP_INACTIVE]: {
    color: themeColor['error-color'],
    label: 'Employee InActive'
  },
  [CARD_STATUSES.DELIVERED]: {
    color: themeColor['primary-color'],
    label: 'Delivered'
  },
}

export const base64ToBlob = (base64, mimeType) => {
  const byteCharacters = atob(base64.split(',')[1]); // Decode Base64
  const byteArrays = [];
  for (let i = 0; i < byteCharacters.length; i += 512) {
    const slice = byteCharacters.slice(i, i + 512);
    const byteNumbers = new Array(slice.length);
    for (let j = 0; j < slice.length; j++) {
      byteNumbers[j] = slice.charCodeAt(j);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }
  return new Blob(byteArrays, { type: mimeType });
};

export const sleepForXSeconds = (timeout) => new Promise((resolve) => setTimeout(() => resolve(true), timeout * 1000))

export const generateQRCodeWithIcon = async (url, iconSrc) => {
  const qrCodeDataUrl = await QRCode.toDataURL(url, {
    errorCorrectionLevel: 'H', // High error correction level to accommodate the icon
    margin: 1,
    width: 200, // Adjust QR code size as needed
  });

  // Create a canvas to overlay the icon
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  // Load the QR code image
  const qrImg = new Image();
  qrImg.src = qrCodeDataUrl;

  return new Promise((resolve) => {
    qrImg.onload = () => {
      const qrSize = 200; // Same as QR code width
      const iconSize = qrSize / 5; // Icon size as a fraction of QR code size
      canvas.width = qrSize;
      canvas.height = qrSize;

      // Draw QR code
      ctx.drawImage(qrImg, 0, 0, qrSize, qrSize);

      // Load and draw the icon
      const iconImg = new Image();
      iconImg.src = iconSrc;
      iconImg.onload = () => {
        const iconX = (qrSize - iconSize) / 2; // Center the icon
        const iconY = (qrSize - iconSize) / 2;
        ctx.drawImage(iconImg, iconX, iconY, iconSize, iconSize);

        // Return the final QR code with the icon as a data URL
        resolve(canvas.toDataURL());
      };
    };
  });
};

export default config;
